;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { useCanaryClient } from '@qogita/deprecated-canary-client/provider'
import { useSuspenseQueries } from '@tanstack/react-query'
import { PAGE_SIZE } from 'src/deprecated/constants'
import { getStocklistSourcesQueryOptions } from 'src/deprecated/hooks/api/useGetStocklistSources'
import { getExpiresIn } from 'src/features/price-lists/get-expires-in'

export function useSuspenseExpiringPriceLists() {
  const canaryClient = useCanaryClient()
  const [expiredPriceListsQuery, warningPriceListsQuery] = useSuspenseQueries({
    queries: [
      {
        ...getStocklistSourcesQueryOptions({
          status: 'expired',
          page: 1,
          pageSize: PAGE_SIZE,
          canaryClient,
        }),
        retry: 0,
      },
      {
        ...getStocklistSourcesQueryOptions({
          status: 'warning',
          page: 1,
          pageSize: PAGE_SIZE,
          canaryClient,
        }),
        retry: 0,
      },
    ],
  })

  const now = new Date()
  const sources = [
    ...expiredPriceListsQuery.data.results,
    ...warningPriceListsQuery.data.results,
  ].map((source) => ({
    ...source,
    expiresIn: getExpiresIn({
      status: source.status,
      expiresAt: source.expiresAt,
      now,
    }),
  }))

  return {
    sources,
    totalResults:
      (expiredPriceListsQuery.data.count ?? 0) +
      (warningPriceListsQuery.data.count ?? 0),
  }
}
